// src/browser/index.ts
var isBrowser = () => {
  return !isWebworker() && globalThis.constructor?.name === "Window";
};
var isWebworker = () => {
  return typeof globalThis === "object" && globalThis.constructor?.name === "DedicatedWorkerGlobalScope";
};
var subtle = globalThis.crypto.subtle;
export {
  isBrowser,
  isWebworker,
  subtle
};
//# sourceMappingURL=index.mjs.map